var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer",attrs:{"id":"footer"}},[_vm._v(" © 2024 "+_vm._s(_vm.appName)+" v"+_vm._s(_vm.appVersion)+" - All Rights Reserved ")])
}
var staticRenderFns = []

export { render, staticRenderFns }